import cx from 'classnames';
import { Transition } from 'react-transition-group';

interface Props {
  testId?: string;
  isVisible?: boolean;
  onClick?: () => void;
  onClosed?: () => void;
  variant?: 'dark' | 'light';
  className?: string;
}

export const Scrim = ({ testId, isVisible = true, onClick, onClosed, variant = 'dark' }: Props) => {
  const transitionStyles: Record<string, string> = {
    entered: 'opacity-100',
    entering: 'opacity-100',
    exited: 'opacity-0',
    exiting: 'opacity-0',
  };

  return (
    <Transition in={isVisible} timeout={150} appear unmountOnExit onExited={onClosed}>
      {state => (
        <>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
          <div
            className={cx(
              'fixed inset-0 z-overlay transition-opacity',
              { 'bg-neutral-20/50': variant === 'dark', 'bg-white/50': variant === 'light' },
              transitionStyles[state],
            )}
            data-testid={testId}
            onClick={onClick}
          />
        </>
      )}
    </Transition>
  );
};
